import { render, staticRenderFns } from "./Poster.vue?vue&type=template&id=00db3c16&"
import script from "./Poster.vue?vue&type=script&lang=ts&"
export * from "./Poster.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports